<template>
  <button role="button" @click="getKakaoToken">
    <slot>
      <sns-logo-circle sns-name="kakao" :width="60" :height="60" />
    </slot>
    <span class="a11y-hidden">카카오로 로그인</span>
  </button>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import { onMounted } from 'vue'

  const emit = defineEmits(['success', 'fail'])

  const loginSuccessCallback = (token) => {
    emit('success', { token })
  }

  const loginFaildCallback = (err) => {
    emit('fail', err)
  }

  const getKakaoToken = () => {
    Kakao.Auth.login({
      success: function () {
        loginSuccessCallback(Kakao.Auth.getAccessToken())
      },
      fail: function (error) {
        loginFaildCallback(error)
      },
    })
  }

  const init = () => {
    if (Kakao && !Kakao.isInitialized()) {
      Kakao.init('30fc7e17b5c56a0ca1e861643292c203')
    }
  }

  onMounted(() => {
    init()
  })
</script>
